import { UserPage } from '@/components/pages'

const UserRoute = () => {
  return <UserPage />
}

UserRoute.layouts = 'content'
UserRoute.displayName = 'UserRoute'
export default UserRoute
